import type { ReactNode } from "react";
import { cn } from "../../../lib/utils.js";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  children?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  children,
  className,
}: EmptyStateProps): React.JSX.Element {
  return (
    <div
      className={cn(
        "grid justify-items-start gap-3 rounded-lg border border-border bg-surface-muted p-6 text-start",
        className,
      )}
    >
      {icon ? <div className="text-subtle">{icon}</div> : null}
      <h3 className="m-0 text-base font-semibold">{title}</h3>
      {description ? <p className="m-0 leading-[1.6] text-muted">{description}</p> : null}
      {children}
    </div>
  );
}
